import { AXIOS_INSTANCE } from 'ap-openapi';
import { PreviewPDFRequest } from './types';

/** todo:
 * For now i using Rest API to call api generate pdf with Axios Instance,
 * Will using connect-es in the future
 */

export const generatePdf = async (data: PreviewPDFRequest) => {
  const response = await AXIOS_INSTANCE.post(
    '/ap.cafe_racer.v1.PDFService/Generate',
    data
  );
  return response.data;
};
